var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atom/Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1228 10.9265C13.1782 9.56531 13.6756 7.85301 13.5138 6.13796C13.352 4.4229 12.5431 2.83392 11.2518 1.69428C9.96048 0.554649 8.28367 -0.0500372 6.5625 0.00324421C4.84133 0.0565256 3.2051 0.763772 1.98668 1.9811C0.767203 3.19927 0.0579269 4.83679 0.00339405 6.55995C-0.0511388 8.28311 0.553176 9.96224 1.69319 11.2551C2.8332 12.548 4.42311 13.3574 6.13893 13.5183C7.85474 13.6793 9.56733 13.1796 10.9277 12.1212L10.9641 12.1593L14.5544 15.7519C14.633 15.8305 14.7264 15.8929 14.8291 15.9355C14.9318 15.9781 15.042 16 15.1532 16C15.2644 16 15.3745 15.9781 15.4772 15.9355C15.58 15.8929 15.6733 15.8305 15.752 15.7519C15.8306 15.6732 15.893 15.5798 15.9355 15.477C15.9781 15.3742 16 15.2641 16 15.1528C16 15.0416 15.9781 14.9314 15.9355 14.8286C15.893 14.7258 15.8306 14.6325 15.752 14.5538L12.1608 10.9621C12.1485 10.9499 12.1358 10.938 12.1228 10.9265ZM10.3657 3.17918C10.8436 3.64951 11.2236 4.20983 11.4839 4.82783C11.7442 5.44583 11.8797 6.10927 11.8824 6.77989C11.8851 7.45051 11.7551 8.11503 11.4998 8.73513C11.2445 9.35523 10.8691 9.91863 10.3951 10.3928C9.92105 10.867 9.35787 11.2427 8.73802 11.498C8.11817 11.7534 7.45391 11.8835 6.78356 11.8807C6.11321 11.878 5.45003 11.7425 4.83228 11.4821C4.21453 11.2217 3.65443 10.8415 3.18429 10.3635C2.24476 9.40811 1.72063 8.12007 1.72609 6.77989C1.73154 5.43971 2.26613 4.15598 3.21341 3.20832C4.16069 2.26066 5.44391 1.72586 6.78356 1.7204C8.12321 1.71494 9.41074 2.23928 10.3657 3.17918Z",
    fill: "#7B7B7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.1f22e1060c33ade2efd4b54d5658f272.svg";
export { ForwardRef as ReactComponent };